import React from "react";
import {FormattedMessage, FormattedTime} from "react-intl";

type WithRequestedTime = {
    requestedTime: string,
};

const getRequestedDate = (order: WithRequestedTime): Date | null => {
    if (order.requestedTime === "ASAP")
        return null;

    const date = new Date(order.requestedTime);
    return isNaN(date.getTime()) ? null : date;
};

type Props = {
    order: WithRequestedTime,
};

const RequestedTime = ({order}: Props) => {
    const requested = getRequestedDate(order);

    if (requested === null) {
        return <FormattedMessage id={"pos.order.asap"}/>;
    }

    return (
        <FormattedTime
            value={requested}
            hour={"2-digit"}
            minute={"2-digit"}
            hourCycle={"h23"}
        />
    );
};

export default RequestedTime;